// extracted by mini-css-extract-plugin
module.exports = {"mainLayout":"ErrorBoundaryContent_mainLayout__NhBQC","container":"ErrorBoundaryContent_container__VhZd7","subtitle":"ErrorBoundaryContent_subtitle__0htsr"};